import { X } from "lucide-react";
import { useEffect } from "react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-tactical font-black text-2xl tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}

export function Btn({ children, variant = "primary", className = "", ...props }) {
  const styles = {
    primary: "bg-emerald-600 hover:bg-emerald-500 text-white",
    ghost: "bg-zinc-900 hover:bg-zinc-800 text-zinc-200 border border-zinc-800",
    danger: "bg-red-600/90 hover:bg-red-500 text-white",
  };
  return (
    <button
      className={`inline-flex items-center gap-2 rounded-sm px-3 py-2 text-sm font-medium transition-colors disabled:opacity-50 ${styles[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="label-caps text-zinc-500">{label}</span>
      <div className="mt-1.5">{children}</div>
    </label>
  );
}

export const inputCls =
  "w-full bg-[#0E0E0E] border border-zinc-800 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-zinc-500 text-zinc-100";

export function Modal({ open, onClose, title, children, wide }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 pt-16 bg-black/70 backdrop-blur-sm" onClick={onClose}>
      <div
        className={`w-full ${wide ? "max-w-2xl" : "max-w-md"} bg-[#121212] border border-zinc-800 rounded-sm shadow-2xl`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-zinc-800">
          <span className="font-tactical font-bold">{title}</span>
          <button onClick={onClose} data-testid="modal-close" className="text-zinc-500 hover:text-white">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="p-5 max-h-[70vh] overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}

export function Card({ children, className = "", ...props }) {
  return (
    <div className={`bg-[#121212] border border-zinc-800 rounded-sm ${className}`} {...props}>
      {children}
    </div>
  );
}
